import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AdminService } from '@app/services/adminService'
import { toast } from '@app/components/ui/Toast/toast'
import { USERS_QUERY_KEY } from '../utils/Admin.constants'

export const useDeleteAdminUser = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (user_uuid: string) => AdminService.deleteUser(user_uuid),
    onSuccess: () => {
      toast({ description: 'User deleted successfully.', type: 'success' })
      queryClient.invalidateQueries({ queryKey: [USERS_QUERY_KEY] })
    },
    onError: () =>
      toast({
        description: `Failed to delete user.`,
        type: 'error',
      }),
  })
}
